<script>
// @ts-check

export default {
  data: function() {
    return {}
  },
}
</script>

<template>
  <v-card style="min-width:320px">
    <v-card-text>
      <b>Attendance</b> - The percentage of days that students were present based on student attendance for the entire school year.
    </v-card-text>
  </v-card>
</template>
